<template>
  <v-container fluid>
    <v-breadcrumbs large class="pa-0" :items="breadcrumbsItems">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <v-tabs>
      <v-tab>Hlavné údaje</v-tab>
      <v-tab>Mapa</v-tab>
      <v-tab>Report</v-tab>
      <v-tab>Body - {{ lokalita.Body.length }}</v-tab>
      <v-tab v-if="lokalita.Stanice.length > 0"
        >SHMÚ Stanice - {{ lokalita.Stanice.length }}</v-tab
      >
      <v-tab v-if="insars.length > 0">Insar</v-tab>
      <v-tab v-if="posunyBodov.length > 0">Pohybová aktivita</v-tab>
      <v-tab v-if="posunyInkBodov.length > 0">Presná inklinometria</v-tab>
      <v-tab>Monitorovanie - graf</v-tab>

      <v-tab-item>
        <v-container class="mt-2 elevation-3" fluid>
          <v-row dense>
            <v-col md="2" class="font-weight-black">ID:</v-col>
            <v-col md="4">{{ lokalita.ID }}</v-col>
            <v-col md="2" class="font-weight-black">Geology ID:</v-col>
            <v-col md="4">{{ lokalita.LOKID }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Lokalita:</v-col>
            <v-col>{{ lokalita.Name }}</v-col>
            <v-col md="2" class="font-weight-black">Katastrálne územie:</v-col>
            <v-col>
              <span v-if="jeKU">{{ lokalita.KU.NM5 }}</span>
            </v-col>
          </v-row>
          <v-row dense v-if="jeKU">
            <v-col md="2" class="font-weight-black">Obec:</v-col>
            <v-col>{{ lokalita.KU.NM4 }}</v-col>
            <v-col md="2" class="font-weight-black">Okres:</v-col>
            <v-col>{{ lokalita.KU.NM3 }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black"
              >Číslo map.listu 1:10 000:</v-col
            >
            <v-col md="4">{{ lokalita.ZM10ZMSM }}</v-col>
            <v-col md="2" class="font-weight-black"
              >Číslo map.listu 1:50 000:</v-col
            >
            <v-col md="4">{{ lokalita.ZM50ZMSM }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black"
              >Názov inž.geol. regiónu:</v-col
            >
            <v-col md="4">{{ lokalita.IgReg }}</v-col>
            <v-col md="2" class="font-weight-black"
              >Názov inž.geol. oblasti:</v-col
            >
            <v-col md="4">{{ lokalita.IgObl }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Plocha:</v-col>
            <v-col md="4">
              {{ lokalita.Plocha }} m
              <sup>2</sup>
            </v-col>
            <v-col md="2" class="font-weight-black">Nadmorská výška:</v-col>
            <v-col md="4"
              >{{ lokalita.Nadm1 }} - {{ lokalita.Nadm2 }} m.n.m.</v-col
            >
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Objem:</v-col>
            <v-col md="4">
              {{ lokalita.Objem }} m
              <sup>3</sup>
            </v-col>
            <v-col md="2" class="font-weight-black">Obdobie:</v-col>
            <v-col md="4">{{ getObdobieString }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Popis:</v-col>
            <v-col>{{ lokalita.Popis }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black"
              >Zobrazovať na verejnej časti:</v-col
            >
            <v-col>{{ lokalita.Zobrazovat ? "Áno" : "Nie" }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black"
              >Zobrazovať za obdobie:</v-col
            >
            <v-col>{{ lokalita.RokOd }} - {{ lokalita.RokDo }}</v-col>
          </v-row>
          <v-row dense>
            <v-col md="2" class="font-weight-black">Literatúra:</v-col>
            <v-col>
              <div v-for="lit in lokalita.Literatura" :key="lit.ID">
                {{ lit.Literatura }}
              </div>
            </v-col>
          </v-row>

          <v-btn @click="editLokalita()" class="mr-1">Editovať</v-btn>
          <v-btn @click="addBod()" class="mr-1">Pridať bod</v-btn>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container class="mt-2 elevation-3" fluid>
          <l-map
            :zoom="zoom"
            :center="center"
            style="height: 600px; width: 100%; z-index: 0"
            ref="map"
            :bounds="bounds"
          >
            <l-control-scale
              position="topright"
              :imperial="false"
              :metric="true"
            ></l-control-scale>
            <l-control position="bottomright">
              <v-img :src="require('../assets/nautical.svg')"></v-img>
            </l-control>
            <l-control-layers position="topright"></l-control-layers>
            <l-tile-layer
              v-for="tileProvider in tileProviders"
              :key="tileProvider.name"
              :name="tileProvider.name"
              :visible="tileProvider.visible"
              :url="tileProvider.url"
              :attribution="tileProvider.attribution"
              layer-type="base"
            />
            <l-geo-json
              v-if="geojson !== null"
              :geojson="geojson"
              :options="{ onEachFeature: onEachFeatureFunction }"
              :optionsStyle="{ color: 'red' }"
            ></l-geo-json>
            <l-control position="topright" v-if="lokalitaHasVrty">
              <v-btn @click="showVrty = !showVrty">
                {{ this.showVrty ? "Schovať vrty" : "Zobraziť vrty" }}
              </v-btn>
            </l-control>
            <template v-if="showVrty && lokalitaHasVrty">
              <l-geo-json
                v-for="(gj, index) in bodyGeojsons"
                :key="'gj' + index"
                :geojson="gj"
                :options="{ onEachFeature: onEachFeatureFunction }"
                :optionsStyle="{ color: 'blue' }"
              ></l-geo-json>
            </template>
            <template v-if="lokalita.Body.length > 0">
              <template v-for="bod in lokalita.Body">
                <l-marker
                  v-if="bod.Lat != 0 && bod.Lng != 0"
                  :lat-lng="[bod.Lat, bod.Lng]"
                  :key="bod.ID"
                  :visible="true"
                >
                  <l-popup :options="bodPopupOptions">
                    <h4>
                      <router-link
                        :to="{ name: 'bod', params: { id: bod.ID } }"
                        >{{ bod.ZNMB }}</router-link
                      >
                    </h4>

                    <v-container>
                      <v-row dense>
                        <v-col md="3" class="font-weight-black">ID:</v-col>
                        <v-col>{{ bod.ID }}</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col md="3" class="font-weight-black">IDMB:</v-col>
                        <v-col>{{ bod.IDMB }}</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col md="3" class="font-weight-black">IDMBP:</v-col>
                        <v-col>{{ bod.IDMBP }}</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col md="3" class="font-weight-black"
                          >X,Y,Z JTSK:</v-col
                        >
                        <v-col>
                          <i>[{{ bod.X }}, {{ bod.Y }}, {{ bod.Z }}]</i>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col md="3" class="font-weight-black">WGS 84:</v-col>
                        <v-col>
                          <i>{{ bod.Lat }}, {{ bod.Lng }}</i>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col md="3" class="font-weight-black">Obdobie:</v-col>
                        <v-col>{{ getObdobieString }}</v-col>
                      </v-row>
                      <v-row dense>
                        <v-col md="3" class="font-weight-black"
                          >Poznámka:</v-col
                        >
                        <v-col>{{ bod.Poznamka }}</v-col>
                      </v-row>
                    </v-container>
                    <v-row dense>
                      <v-col class="font-weight-black">Dostupné merania:</v-col>
                    </v-row>
                    <template v-for="m in merania">
                      <v-row dense :key="m.type" v-if="m.count(bod) > 0">
                        <v-col>{{ m.name }} - {{ m.count(bod) }}</v-col>
                      </v-row>
                    </template>
                    <v-container></v-container>
                  </l-popup>
                </l-marker>
              </template>
            </template>
          </l-map>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container v-if="report !== null" fluid class="pt-6">
          <v-range-slider
            label="Výber zobrazených rokov (stĺpcov)"
            v-model="reportYears"
            step="1"
            :min="report.years[0]"
            :max="report.years[1]"
            ticks="always"
            tick-size="4"
            thumb-label="always"
          ></v-range-slider>
          <v-simple-table>
            <template v-slot:default>
              <thead class="reportTable">
                <tr>
                  <th
                    class="text-center"
                    rowspan="2"
                    style="border-bottom: thin solid rgba(0, 0, 0, 0.12)"
                  >
                    Metódy
                    <br />monitorovania
                  </th>
                  <th class="text-center" colspan="2">Monitorovacie objekty</th>
                  <th class="text-center" :colspan="reportYearsAll.length">
                    Počet uskutočnených meraní
                    <br />(dátum merania)
                  </th>
                </tr>
                <tr>
                  <th class="text-center">Počet za<br />všetky roky</th>
                  <th class="text-center">
                    Názvy monitorovaných bodov<br />za všetky roky
                  </th>
                  <th
                    class="text-center"
                    v-for="rok in reportYearsAll"
                    :key="rok"
                  >
                    Rok {{ rok }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in report.data" :key="index">
                  <td class="text-left">{{ item.Meranie }}</td>
                  <td class="text-center">{{ item.Body }}</td>
                  <td class="text-center">{{ item.Znacky.join(", ") }}</td>
                  <td
                    class="text-center"
                    v-for="rok in reportYearsAll"
                    :key="rok"
                  >
                    {{ item.RokPocet[rok] }}
                    <br />
                    {{ item.RokDates[rok] }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-data-table
          :headers="bodyheaders"
          :items="lokalita.Body"
          :items-per-page="10"
          sort-by="IDMB"
          class="elevation-1 clickableTable"
          :custom-sort="customSort"
          @click:row="viewBod($event)"
        >
          <template v-slot:item.merania="{ item }">
            <template v-for="meranie in meraniaTypy">
              <span
                :key="meranie"
                style="display: inline-block; width: 30px"
                v-if="getMeranieCountIconName(item, meranie) !== ''"
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      {{ getMeranieCountIconName(item, meranie) }}
                    </v-icon>
                  </template>
                  <span>
                    {{ getMeranieCountText(item, meranie) }} -
                    {{ getMeranieCountPocet(item, meranie) }}
                  </span>
                </v-tooltip>
              </span>
            </template>
          </template>
        </v-data-table>
        <div class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <download-excel :data="lokalita.Body" class="exportXLS">
                <v-icon v-on="on">mdi-microsoft-excel</v-icon>
              </download-excel>
            </template>
            <span>Export do xls</span>
          </v-tooltip>
        </div>
      </v-tab-item>
      <v-tab-item v-if="lokalita.Stanice.length > 0">
        <v-data-table
          :headers="staniceHeaders"
          :items="lokalita.Stanice"
          :items-per-page="10"
          sort-by="ID"
          class="elevation-1 clickableTable"
          @click:row="viewStanica($event)"
        ></v-data-table>
        <div class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <download-excel :data="lokalita.Stanice" class="exportXLS">
                <v-icon v-on="on">mdi-microsoft-excel</v-icon>
              </download-excel>
            </template>
            <span>Export do xls</span>
          </v-tooltip>
        </div>
      </v-tab-item>
      <v-tab-item v-if="insars.length > 0">
        <v-data-table
          :headers="insarHeaders"
          :items="insars"
          :items-per-page="10"
          sort-by="ID"
          class="elevation-1 clickableTable"
          @click:row="viewInsar"
        >
          <template v-slot:top>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <download-excel :data="insars" class="exportXLS">
                  <v-icon v-on="on">mdi-microsoft-excel</v-icon>
                </download-excel>
              </template>
              <span>Export do xls</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-tab-item>

      <v-tab-item v-if="posunyBodov.length > 0">
        <v-container class="mt-2 elevation-3" fluid>
          <geo-pohybova-aktivita
            :body="posunyBodov"
            :bounds="bounds"
          ></geo-pohybova-aktivita>
        </v-container>
      </v-tab-item>
      <v-tab-item v-if="posunyInkBodov.length > 0">
        <v-container class="mt-2 elevation-3" fluid>
          <ink-pohybova-aktivita
            :lokalitaId="lokalita.ID"
            :posuny="posunyInkBodov"
          ></ink-pohybova-aktivita>
        </v-container>
      </v-tab-item>
      <v-tab-item>
        <v-container class="mt-2 elevation-3" fluid>
          <lokalita-chart
            typ="monitorLokalita"
            :lokalita="lokalita"
          ></lokalita-chart>
        </v-container>
      </v-tab-item>
    </v-tabs>

    <lokalita-detail
      ref="dialogLokalita"
      @change="readLokalita(lokalita.ID)"
    ></lokalita-detail>
    <bod-detail
      ref="dialogBod"
      @change="readLokalita(lokalita.ID)"
    ></bod-detail>
    <v-overlay :value="loading">
      <v-progress-circular
        :size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import LokalitaDetail from "../components/LokalitaDetail.vue"
import BodDetail from "../components/BodDetail.vue"
import * as L from "leaflet"
import {
  LMap,
  LTileLayer,
  LMarker,
  LGeoJson,
  LPopup,
  LControl,
  LControlLayers,
  LControlScale
} from "vue2-leaflet"
import * as Miscella from "../plugins/miscella.js"
import * as Enums from "../plugins/enums.js"
import DownloadExcel from "vue-json-excel"
import GeoPohybovaAktivita from "../components/GeoPohybovaAktivita.vue"
import InkPohybovaAktivita from "../components/InkPohybovaAktivita.vue"
import LokalitaChart from "./Chart.vue"

export default {
  props: ["id"],
  components: {
    BodDetail,
    DownloadExcel,
    LGeoJson,
    LMap,
    LControl,
    LControlLayers,
    LControlScale,
    LMarker,
    LokalitaDetail,
    LPopup,
    LTileLayer,
    GeoPohybovaAktivita,
    InkPohybovaAktivita,
    LokalitaChart
  },

  data: () => ({
    tab: 0,
    meraniaTypy: Enums.TYPY,
    lokalita: {
      ID: null,
      Name: "",
      Body: [],
      Stanice: []
    },
    report: null,
    reportYears: [],
    insars: [],

    geojson: null,
    showVrty: true,
    bodyGeojsons: [],
    bounds: null,
    insar: {
      Body: []
    },

    bodyheaders: [
      { text: "IDMB", align: "left", sortable: true, value: "IDMB" },
      { text: "Bod", align: "left", sortable: true, value: "ZNMB" },
      { text: "X", align: "right", sortable: false, value: "X" },
      { text: "Y", align: "right", sortable: false, value: "Y" },
      { text: "Z", align: "right", sortable: false, value: "Z" },
      { text: "Metódy", align: "right", sortable: false, value: "merania" }
    ],

    insarHeaders: [
      { text: "ID", align: "left", sortable: true, value: "ID" },
      {
        text: "Názov súboru",
        align: "left",
        sortable: false,
        value: "Filename"
      },
      { text: "Misia", align: "left", sortable: false, value: "Misia" },
      { text: "Poznámka", align: "left", sortable: false, value: "Poznámka" }
    ],

    staniceHeaders: [
      { text: "ID", align: "left", sortable: true, value: "ID" },
      { text: "Stanica", align: "left", sortable: true, value: "Stanica" },
      { text: "Indikatív", align: "left", sortable: true, value: "Indik" },
      {
        text: "Počet meraní",
        align: "right",
        sortable: true,
        value: "ZrazkyCount"
      }
    ],

    mapOptions: {
      zoomSnap: 0.5
    },

    zoom: 8,
    center: [48.6, 19.7],
    merania: [
      {
        name: "DILAT",
        type: "dilat",
        count: bod => bod.DilatsCount
      },
      {
        name: "HPV",
        type: "hpv",
        count: bod => bod.HpvsCount
      },
      {
        name: "MB HPV",
        type: "mb_hpv",
        count: bod => bod.MbHpvsCount
      },
      {
        name: "HPVQ",
        type: "hpvq",
        count: bod => bod.HpvqsCount
      },
      {
        name: "INKP",
        type: "inkp",
        count: bod => bod.InkpsCount
      },
      {
        name: "INKS",
        type: "inks",
        count: bod => bod.InkssCount
      },
      {
        name: "GEO",
        type: "geo",
        count: bod => bod.GeosCount
      },
      {
        name: "PRNA",
        type: "prna",
        count: bod => bod.PRNAsCount
      },
      {
        name: "STABSKAL",
        type: "stab",
        count: bod => bod.StabsCount
      },
      {
        name: "MIKRONIV",
        type: "mikro",
        count: bod => bod.MikrosCount
      },
      {
        name: "PT",
        type: "pt",
        count: bod => bod.PTsCount
      },
      {
        name: "POTRUB",
        type: "potrub",
        count: bod => bod.PotrubsCount
      },
      {
        name: "PEEP",
        type: "peep",
        count: bod => bod.PEEPsCount
      },
      {
        name: "PEES",
        type: "pees",
        count: bod => bod.PEESsCount
      },
      {
        name: "MB POTRUB",
        type: "mb_potrub",
        count: bod => bod.MbPotrubsCount
      },
      {
        name: "MB DILAT",
        type: "mb_dilat",
        count: bod => bod.MbDilatsCount
      },
      {
        name: "MB STABSKAL",
        type: "mb_stab",
        count: bod => bod.MbStabsCount
      },
      {
        name: "MB MIKRONIV",
        type: "mb_mikro",
        count: bod => bod.MbMikrosCount
      },
      {
        name: "MB INK",
        type: "mb_ink",
        count: bod => bod.MbInksCount
      }
    ],
    posunyBodov: [],
    posunyInkBodov: [],
    customSort: Miscella.customSort,
    tileProviders: [
      {
        name: "OpenTopoMap",
        visible: false,
        attribution:
          'Map data: &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)',
        url: "https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
      },
      {
        name: "FreeMapSk",
        visible: true,
        attribution:
          '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, vizualization CC-By-SA 2.0 <a href="http://freemap.sk">Freemap.sk</a>',
        url: "https://{s}.freemap.sk/T/{z}/{x}/{y}.jpeg"
      },
      {
        name: "ZBGIS",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="https://zbgis.skgeodesy.sk/">ZBGIS</a>',
        url:
          "https://zbgis.skgeodesy.sk/zbgis/rest/services/ZBGIS/MapServer/tile/{z}/{y}/{x}"
      },
      {
        name: "OpenStreetMap",
        visible: true,
        attribution:
          '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      }
    ],
    loading: false
  }),
  computed: {
    breadcrumbsItems: function() {
      return [{ text: "Lokalita " + this.lokalita.Name }]
    },
    lokalitaHasVrty: function() {
      let ret = false
      for (let i = 0; i < this.lokalita.Body.length; i++) {
        const bod = this.lokalita.Body[i]
        if (bod.GeomLines && bod.GeomLines !== "") {
          ret = true
        }
      }
      return ret
    },
    jeKU: function() {
      let ret = false
      if (Miscella.isSet(this.lokalita.KU)) {
        if (this.lokalita.KU.ObjectID !== 0) {
          ret = true
        }
      }
      return ret
    },
    getObdobieString: function() {
      let ret = this.lokalita.DatumOdString
      if (ret !== "") {
        ret += " - "
      }
      ret += this.lokalita.DatumDoString
      return ret
    },
    bodPopupOptions: function() {
      return {
        minWidth: 500,
        autoPanPaddingTopLeft: L.point(50, 10)
      }
    },
    reportYearsAll: function() {
      let ret = []
      let start = this.reportYears[0]
      let end = this.reportYears[1]
      for (let i = start; i <= end; i++) {
        ret.push(i)
      }
      return ret
    }
  },
  methods: {
    editLokalita: function() {
      this.$refs.dialogLokalita.show(this.lokalita)
    },
    addBod: function() {
      this.$refs.dialogBod.show({
        ID: null,
        LokalitaID: this.lokalita.ID,
        Lokalita: this.lokalita
      })
    },
    readLokalita: async function(id) {
      console.log("Lokalita.vue, readLokalita, id=" + id)
      try {
        this.loading = true
        let response = await this.$axios.get("/r/lokalita/" + id)
        if (response.status === 200) {
          this.readLokalitaReport(id)
          this.lokalita = this.transformItem(response.data)
          if (this.lokalita.Geometria && this.lokalita.Geometria !== "") {
            this.geojson = {
              type: "Feature",
              properties: {
                name: this.lokalita.Name,
                description: this.lokalita.Popis
              },
              geometry: JSON.parse(this.lokalita.Geometria)
            }
            var bbox = this.geojson.geometry.bbox
            this.bounds = [
              L.latLng(bbox[1], bbox[0]),
              L.latLng(bbox[3], bbox[2])
            ]
          } else {
            //vypocitaj bounds z bodov
            let latMin = null
            let latMax = null
            let lngMin = null
            let lngMax = null
            console.log("Setting bounds 0")
            for (let i = 0; i < this.lokalita.Body.length; i++) {
              const bod = this.lokalita.Body[i]
              if (bod.Lng && bod.Lat) {
                if (i === 0) {
                  latMin = bod.Lat
                  latMax = bod.Lat
                  lngMin = bod.Lng
                  lngMax = bod.Lng
                } else {
                  latMin = Math.min(latMin, bod.Lat)
                  latMax = Math.max(latMax, bod.Lat)
                  lngMin = Math.min(lngMin, bod.Lng)
                  lngMax = Math.max(lngMax, bod.Lng)
                }
              }
            }
            this.bounds = [
              [latMax, lngMin],
              [latMin, lngMax]
            ]
            console.log("Setting bounds to", this.bounds)
          }
          for (let i = 0; i < this.lokalita.Body.length; i++) {
            const bod = this.lokalita.Body[i]
            if (bod.GeomLines && bod.GeomLines !== "") {
              let bodGeojson = {
                type: "Feature",
                properties: {
                  name: bod.ZNMB,
                  description: bod.Poznamka
                },
                geometry: JSON.parse(bod.GeomLines)
              }
              this.bodyGeojsons.push(bodGeojson)
            }
          }
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      } finally {
        this.loading = false
      }
    },
    readLokalitaReport: async function(id) {
      console.log("Lokalita.vue, readLokalitaReport, id=" + id)
      try {
        let response = await this.$axios.get(
          "/report/lokalita?lokalitaid=" + id
        )
        if (response.status === 200) {
          this.report = response.data
          this.reportYears = [this.report.years[0], this.report.years[1]]
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readInsars: async function(id) {
      try {
        let response = await this.$axios.get(`/r/lokalita/${id}/insars`)
        if (response.status === 200) {
          this.insars = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readInsar: async function() {
      try {
        let id = 1923998
        let response = await this.$axios.get("/r/insar/" + id)
        if (response.status === 200) {
          this.insar = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readPosunyBodov: async function(id) {
      try {
        let response = await this.$axios.get(`/r/lokalita/${id}/posunyBodov`)
        if (response.status === 200) {
          this.posunyBodov = response.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    readPosunyInkBodov: async function(id) {
      try {
        let response = await this.$axios.get(`/lokalita/${id}/posunyInkBodov`)
        if (response.status === 200) {
          this.posunyInkBodov = response.data.data
        } else {
          this.$store.commit("alert", response.data.Error)
        }
      } catch (error) {
        this.$store.commit("alert", error.toString())
      }
    },
    transformItem: function(item) {
      item.DatumOd = Miscella.zeroDatum(item.DatumOd)
      item.DatumDo = Miscella.zeroDatum(item.DatumDo)
      item.DatumOdString = Miscella.formatDatum(item.DatumOd)
      item.DatumDoString = Miscella.formatDatum(item.DatumDo)
      for (let i = 0; i < item.Body.length; i++) {
        let bod = item.Body[i]
        bod.DatumOd = Miscella.zeroDatum(bod.DatumOd)
        bod.DatumDo = Miscella.zeroDatum(bod.DatumDo)
        bod.DatumOdString = Miscella.formatDatum(bod.DatumOd)
        bod.DatumDoString = Miscella.formatDatum(bod.DatumDo)
      }
      return item
    },
    viewBod: function(bod) {
      this.$router.push({ name: "bod", params: { id: bod.ID } })
    },
    viewStanica: function(stanica) {
      this.$router.push({
        name: "stanica",
        params: { lokalitaId: this.id, id: stanica.ID }
      })
    },
    viewInsar: function(insar) {
      this.$router.push({ name: "insar", params: { id: insar.ID } })
    },
    onEachFeatureFunction: function(feature, layer) {
      layer.bindPopup(
        "<h4>" +
          feature.properties.name +
          "</h4><p>" +
          feature.properties.description +
          "</p>",
        { permanent: false, sticky: true }
      )
    },
    getMeranieCountIconName: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.iconName
    },
    getMeranieCountText: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.text
    },
    getMeranieCountPocet: function(bod, meranie) {
      let ret = this.getMeranieCountItem(bod, meranie)
      return ret.pocet
    },
    getMeranieCountItem: function(bod, meranie) {
      let ret = Enums.getMeranieCountItem(bod, meranie)
      ret.text = "Počet vykonaných meraní: " + ret.text
      return ret
    }
  },

  mounted: async function() {
    await this.$store.dispatch("fetchme", this.$axios)
    this.readLokalita(this.id)
    this.readInsars(this.id)
    this.readPosunyBodov(this.id)
    this.readPosunyInkBodov(this.id)
  }
}
</script>
<style></style>
//TODO https://www.nayuki.io/res/convex-hull-algorithm/convex-hull.js
